import SimpleStore from '../../../../utils/simpleStore';
export var TEAM_ACCOUNT_OFFICE_COOKIE = 'ddfw_team_account_office';
export var getDefaultTeamAccountOfficeIdFromCookie = function (teamAccountId) {
    var teamAccountOfficeMap = SimpleStore.get(TEAM_ACCOUNT_OFFICE_COOKIE) || {};
    var defaultTeamAccountOfficeId = teamAccountOfficeMap[teamAccountId];
    return defaultTeamAccountOfficeId || '';
};
export var setDefaultTeamAccountOfficeIdToCookie = function (teamAccountId, officeId) {
    var teamAccountOfficeMap = SimpleStore.get(TEAM_ACCOUNT_OFFICE_COOKIE) || {};
    // set teamAccount-officeId pair
    teamAccountOfficeMap[teamAccountId] = officeId;
    // save new cookie
    SimpleStore.set(TEAM_ACCOUNT_OFFICE_COOKIE, teamAccountOfficeMap);
};
